import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'ConsumableLifetimeCycle',
  //   description: 'description of ConsumableLifetimeCycle',
  //   url: '/consumable-lifetime-cycle',
  // },
];

export default help;
